/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import PipelineRegularAi from './pipeline-regular-ai-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <PipelineRegularAi {...validProps} />;
}
SvgComponent.iconName = 'pipelineRegularAi';

export const PipelineRegularAiIcon = svgIconWrapper(SvgComponent);
